// src/pages/pedidos/TipoEntregaSearch.js
import React, { useEffect, useRef, useState } from 'react';
import { FaSortDown, FaSortUp } from 'react-icons/fa';

import { useTipoEntrega } from '../../contexts/pedidos/TipoEntregaContext';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalTable from '../../components/modalForm/ModalTable';
import LazyLoading from '../../components/modalForm/LazyLoading';
import ModalSearchBar from '../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../components/modalForm/ModalActions';
import ModalSelectButton from '../../components/modalForm/ModalSelectButton';

const TipoEntregaSearch = ({ show, onHide, onSelectTipoEntrega }) => {
    const { tiposEntrega } = useTipoEntrega();
    const [filter, setFilter] = useState('');

    const [sortField, setSortField] = useState('id');
    const [sortDirection, setSortDirection] = useState('asc');

    const inputRef = useRef(null);

    useEffect(() => {
        if (show) {
            setFilter('');

            if (inputRef.current) {
                inputRef.current.focus();
            }
        }
    }, [show]);

    if (!show) return null;

    const filteredTiposEntrega = tiposEntrega.filter(tipoEntrega =>
        String(tipoEntrega?.descricao || '').toLowerCase().includes(filter.toLowerCase())
    );

    const sortedTiposEntrega = filteredTiposEntrega.sort((a, b) => {
        if (sortField === 'id') {
            return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        }

        if (sortField === 'descricao') {
            const descriptionA = String(a?.descricao || '').toLowerCase();
            const descriptionB = String(b?.descricao || '').toLowerCase();

            if (descriptionA < descriptionB) return sortDirection === 'asc' ? -1 : 1;
            if (descriptionA > descriptionB) return sortDirection === 'asc' ? 1 : -1;
        }

        return 0;
    });

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (tipoEntrega) => {
        onSelectTipoEntrega(tipoEntrega);
        onHide();
    };

    return (
        <ModalContainer show={show} variant="busca" onHide={onHide}>
            <ModalHeader title="Buscar Tipo de Entrega" onHide={onHide} />
            <ModalBody>
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por descrição..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>
                <LazyLoading items={sortedTiposEntrega} resetKey={JSON.stringify([show, filter, sortField, sortDirection])}>
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
                    <thead>
                        <tr>
                            <th className="text-center align-middle" scope="col" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('id')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} tabIndex={0} type="button">
                                    Id
                                    {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-start align-middle" scope="col" style={{ width: '60%' }} aria-sort={sortField === 'descricao' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('descricao')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} tabIndex={0} type="button">
                                    Descrição
                                    {sortField === 'descricao' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle" scope="col" style={{ width: '15%' }}>Taxa</th>
                            <th className="text-center align-middle modal-select-column" scope="col" style={{ width: '15%' }}>Selecionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map((tipoEntrega) => (
                            <tr key={tipoEntrega.id} onDoubleClick={() => handleDoubleClick(tipoEntrega)}>
                                <td className="text-end align-middle">{tipoEntrega.id}</td>
                                <td className="align-middle">{tipoEntrega.descricao}</td>
                                <td className="text-center align-middle">{tipoEntrega.temTaxaEntrega ? 'Sim' : 'Não'}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton className="btn btn-outline-secondary btn-sm" onClick={() => onSelectTipoEntrega(tipoEntrega)} style={{ padding: '2px 6px' }} label={tipoEntrega.descricao} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>
            <ModalFooter>

                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">
                    Fechar
                </ModalActionButton>
            </ModalFooter>
        </ModalContainer>
    );
};

export default TipoEntregaSearch;
